import { sanitizeMetadata } from '@jotpsych/statsig';

import { EventNames } from '@services/statsig/constants';

// Import the global Statsig client instance (set by StatsigProvider)
// This allows error tracking from non-React contexts like RTK Query
let statsigClientInstance: {
  logEvent: (name: string, value?: number, metadata?: Record<string, string>) => void;
} | null = null;

/**
 * Set the Statsig client instance for error tracking in non-React contexts
 * Called by StatsigProvider during initialization
 */
export function setNotificationStatsigClient(client: {
  logEvent: (name: string, value?: number, metadata?: Record<string, string>) => void;
}) {
  statsigClientInstance = client;
}

/**
 * Track system notification fetch errors
 * Safe to call even if Statsig is not initialized - will fail silently
 */
export function trackNotificationFetchError(error: Error | string, statusCode?: number): void {
  try {
    if (!statsigClientInstance) {
      return; // Fail silently if client not initialized
    }

    const errorMessage = error instanceof Error ? error.message : String(error);
    const sanitizedMetadata = sanitizeMetadata({
      error_message: errorMessage,
      ...(statusCode && { status_code: String(statusCode) }),
    });

    statsigClientInstance.logEvent(EventNames.SYSTEM_NOTIFICATION_FETCH_ERROR, undefined, sanitizedMetadata);
  } catch {
    // Fail silently - error tracking should not break the app
  }
}
